import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'textnote-dialog-component',
    styleUrls: ['textnote.dialogcomponent.css'],
    templateUrl: 'textnote.dialogcomponent.html'
})
export class TextNoteDialogComponent implements OnInit {
    canceltext: string;
    title: string;
    message: string;
    oktext: string;
    note: string;
    showIcon: boolean;

    constructor(public dialogRef: MatDialogRef<TextNoteDialogComponent>, @Inject(MAT_DIALOG_DATA) data: _TextNoteDialogOptions) {
        this.canceltext = data.CancelText || 'Cancel';
        this.oktext = data.OKText || 'OK';
        this.title = data.TitleText || 'Optional Note';
        this.message = data.MessageText || '';
        this.note = data.Note || '';
        this.showIcon = (data.ShowIcon != null ? data.ShowIcon : false);
    }
    
    ngOnInit() {

    }

    OKHandler() {
        this.dialogRef.close(this.note);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }
}

// #region Custom Classes

export class _TextNoteDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Note?: string;
}

// #endregion


// WEBPACK FOOTER //
// ./src/services/dialogs/textnote/textnote.dialogcomponent.ts